import Spinner from "../ui/spinner";

function Loader(props:{className?:string, message?: string}) {
  return (
    <div>
      <div
        className={`absolute w-full h-full grid place-content-center  bg-[#7b797936] z-10  ${props.className} `}
      >
        <div className={`flex items-center flex-col`}>
          <Spinner color="#130B40" className="h-20 w-20" />
          {props.message && <p className="text-lg mt-2">{props.message}</p>}
        </div>
      </div>
    </div>
  );
}

export default Loader;
